import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementPostApproval } from "./selectorIsRequirementPostApproval";

export const selectorIsRequirementRejected = (
  requirement: IRequirementResponse
) => {
  const isRequirementIncomplete =
    requirement.status === RequirementStatus.Incomplete;

  return (
    selectorIsRequirementPostApproval(requirement) && isRequirementIncomplete
  );
};
